import { useSelector } from 'react-redux';
import { getUserSelector } from 'reducers/user';

export const useUser = () => useSelector(getUserSelector);
